import React from 'react';
import Lottie from 'lottie-react';
import testIcon from '../../assert/Dev.json';

const DevIcon = () => (
    // <div className="test-icon">
    <div className="dev-icon">
        <Lottie animationData={testIcon} loop className="animation"/>
    </div>
);
export default DevIcon;
